import React from 'react'
import { Text } from '@adc/ui-adc'
import _cx from 'classnames/bind'
import MatchBidIcon from './matchBidLogo.svg'
import cls from './styles.scss'

const cx = _cx.bind(cls)

const MatchBidHeader = () => {
  return (
    <span>
      <img
        src={MatchBidIcon}
        alt='match bid logo'
        data-elm-id='match_bid_logo'
        className={cx('match-bid-logo')}
      />
    </span>
  )
}

export default MatchBidHeader

export const matchBidHeaderContent = () => (
  <>
    <div data-elm-id='match_bidding_cta_header_content'>
      <MatchBidHeader />
    </div>
    <div data-elm-id='match_bidding_cta_body_content'>
      <Text>
        Match The Bid properties allow bidders the opportunity to place the same
        bid as the winner. If the winner does not execute, properties will be
        granted to users that match the bid. Learn More:{' '}
        <a
          target='_BLANK'
          data-elm-id='match_bidding_cta'
          href='/lp/match-the-bid'
          rel='noreferrer'
        >
          View Match The Bid FAQ’s.
        </a>
      </Text>
    </div>
  </>
)
